// extracted by mini-css-extract-plugin
export default {"compare_null_content":"style_compare_null_content__h4uIO","empty_compare_img":"style_empty_compare_img__NM5it","empty_compare_page":"style_empty_compare_page__+CFvk"};